import { Dayts, QueryInputType, queryInput } from '@/utils';
import { Import, ImportWithAirportConnectionInput, ImportWithAirportSearch } from '@/models/gen/graphql';

import { AddonsTypes } from '@/features/Addons/types';
import { DATETIME_RFC_FORMAT } from '@/constants';
import { SearchAddonTableDocument } from '@/api/queries';
import graphApi from '@/api';

const [, runRefetchSearchAddonTable] = graphApi(SearchAddonTableDocument);

const searchAddonTable = async (...queries: AddonsTypes.Query[]) => {
  const input: ImportWithAirportConnectionInput = {
    first: 1000,
    after: null,
    query: queries.map((query) => {
      const output: ImportWithAirportSearch = {
        archivedAt: queryInput([], QueryInputType.ISNULL),
        airportCode: queryInput.orNull(query.airportCode, QueryInputType.OR),
        providerId: queryInput.orNull(query.providerId, QueryInputType.OR),
        type: queryInput(query.type, QueryInputType.OR),
        status: queryInput.orNull(query.status, QueryInputType.OR),
      };

      const dateInput = queryInput(
        [new Dayts(query.from).startOf('day').format(DATETIME_RFC_FORMAT), new Dayts(query.to).endOf('day').format(DATETIME_RFC_FORMAT)],
        QueryInputType.RANGE
      );
      const userIdInput = queryInput(query.createdBy, QueryInputType.OR);

      // Archived
      if (query.archived) {
        output.archivedAt = dateInput;
        output.archivedBy = userIdInput;
        return output;
      }

      // Not archived
      output.createdAt = dateInput;
      output.createdBy = userIdInput;

      return output;
    }),
  };

  return await runRefetchSearchAddonTable({ input });
};

export const searchAddonTableWithMetadata = async (...queries: AddonsTypes.Query[]): Promise<{ imports: Import[]; totalCount: number }> => {
  const res = await searchAddonTable(...queries);

  return {
    imports: res?.searchImports?.importWithAirportConnection?.edges.map((edge) => edge.node as unknown as Import) || [],
    totalCount: res?.searchImports?.importWithAirportConnection?.totalCount || 0,
  };
};

export default searchAddonTable;
